import { FunctionComponent, ReactNode } from 'react';
import { Form } from 'softcat:components/form.tsx';

type FormStaticValueProperties = {
    label: ReactNode;
    value: ReactNode | string;
};

export const FormStaticValue: FunctionComponent<FormStaticValueProperties> = ({ label, value }) => {
    return (
        <div className="sm:grid sm:grid-cols-4 sm:items-start sm:gap-4" data-testid={'form-static-value'}>
            <Form.Label>{label}</Form.Label>

            <div className="mt-2 text-sm text-gray-400 sm:col-span-3 sm:mt-0 sm:pt-2">
                <p>{value}</p>
            </div>
        </div>
    );
};
